import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFuture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path d="M10.86 9.37c1.39 2.04.32 3.94-1.31 5.53l-2.12-3.52" fill="white" />
    <path d="M6.63 5.14C4.6 3.75 2.7 4.82 1.1 6.45l3.52 2.12" fill="white" />
    <path
      d="M6.63 5.14C4.6 3.75 2.7 4.82 1.1 6.45l3.52 2.12"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.86 9.37c1.39 2.04.32 3.94-1.31 5.53l-2.12-3.52"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.47 1.53s1.47 3.46-1.06 5.98c-.71.74-1.94 1.52-3.3 2.32L6.16 5.9c.8-1.37 1.58-2.6 2.32-3.31C11 .06 14.47 1.53 14.47 1.53"
      fill="#ECF1FF"
    />
    <path
      d="M7.44 11.38 4.62 8.56l.93-1.58q.31-.56.62-1.08l3.93 3.93-1.03.6q-.83.46-1.63.95"
      fill="white"
    />
    <path
      d="m4.62 8.56 2.82 2.82c2.25-1.35 4.8-2.66 5.97-3.87 2.53-2.52 1.06-5.98 1.06-5.98S11.01.06 8.5 2.59C7.28 3.75 5.96 6.32 4.62 8.56"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m6.17 5.9 3.93 3.93"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.72 4.82c.29 0 .53-.24.53-.54 0-.29-.24-.53-.54-.53-.29 0-.53.24-.53.53s.24.54.54.54"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.48 13.77c-.62.6-3.38 1.13-3.38 1.13s.53-2.76 1.13-3.38q.22-.23.51-.37t.62-.13.63.11.53.35.35.53.11.63q0 .32-.14.62-.12.3-.36.51"
      fill="#ECF1FF"
    />
    <path
      d="M4.48 13.77c-.62.6-3.38 1.13-3.38 1.13s.53-2.76 1.13-3.38q.22-.23.51-.37t.62-.13.63.11.53.35.35.53.11.63q0 .32-.14.62-.12.3-.36.51"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIconFuture;
